import React from 'react';
import funcspritelogo from '@trv-ebus/tds-icons/dist/assets/icons/functional/symbol-sprites.svg';
const LoadingSpinner = ( ) => {

  const spinnerStyle = {
        textAlign: 'center',
        margin: '30%'
  }; 
  
  return ( 
        <div style={spinnerStyle}>
            <span className="tds-pl-sm"  aria-label="spinnericon" data-testid="spinner">
                <svg className="tds-icon-24 tds-spin" focusable="false" data-testid="spinnericon">
                    <use xlinkHref= {funcspritelogo + "#arrow-cycle-1-24" }></use>
                </svg>
            </span>             
        </div>  
    );
};

export default LoadingSpinner;